export default __webpack_public_path__ + "static/media/tk.e770bcfe.svg";